import { CHANGE_MAPSCALE_SCALE, TOGGLE_OPTIONAL_MAPSCALE } from './constants';
import { CHANGE_MAP_SCALE } from '../map/constants';
import { changePreviewHiddenComponents } from '../../actions';
export const toggleOptional = (isChecked, componentIdent) => (dispatch) => {
    dispatch({
        type: TOGGLE_OPTIONAL_MAPSCALE,
        isHidden: !isChecked,
        componentIdent,
    });
    dispatch(changePreviewHiddenComponents());
};
export const changeScale = (scale, componentIdent) => (dispatch, getState) => {
    const state = getState();
    const mapIdent = state[componentIdent].map || componentIdent;
    /** neni nutne emitovat, stane se po zmene mapy */
    dispatch({
        type: CHANGE_MAPSCALE_SCALE,
        scale,
        componentIdent,
    });
    const map = state['map'];
    if (mapIdent && map.minMaxScale.minScale <= scale && scale <= map.minMaxScale.maxScale) {
        dispatch({
            type: CHANGE_MAP_SCALE,
            scale,
            componentIdent: mapIdent,
        });
    }
};
//# sourceMappingURL=actions.js.map